import {
  formVeeErrorMixin,
  formErrorMixin,
  formValidationMixin
} from "../../../mixins";

export default {
  mixins: [formVeeErrorMixin, formValidationMixin],

  data() {
    return {
      isForm: true
    };
  },

  $_veeValidate: {
    validator: "new"
  },

  render(h) {
    const t = this;
    return h(
      "form",
      {
        ref: "form",
        class: ["form"],
        attrs: {
          novalidate: true
        },
        on: {
          submit: t.handleSubmit
        }
      },
      [this.$slots.default]
    );
  },

  methods: {
    handleSubmit(event) {
      event.preventDefault();
      this.validate().then(result => {
        if (result) this.$emit("submit", event);
      });
    }
  }
};
